/**
 *
 * @param publicID
 */
export function publicIDContainsVersion(publicID) {
  return publicID.match(/^v[0-9]+/);
}